import { logo } from "assets/images";
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.scss";
import Avatar from "./Avatar";
import { getFromLocal } from "config/axiosInstance";
import { FaBars,FaTimes  } from "react-icons/fa";

const DashboardHeader = () => {
  const [scroll, setScroll] = useState(false);
  const loginToken = getFromLocal();
  const [mobileMenu, setMobileMenu] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);

  useEffect(() => {
    document.body.classList.toggle("mobile_open", mobileMenu);
  }, [mobileMenu]);
  return (
    <>
      <header className={`header ${scroll ? "scrolledHeader" : ""}`}>
        <div className="container">
          <div className="logo">
            <Link to="/">
              <img src={logo} alt="" />
            </Link>
          </div>

          <div className="right_button_wrap">
            <Avatar />
            <button
              type="button"
              className="mobile_button"
              onClick={() => setMobileMenu(!mobileMenu)}
            >
              {mobileMenu ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </header>
      <div className="overlay" onClick={() => setMobileMenu(false)}></div>
    </>
  );
};

export default DashboardHeader;
